import classnames from 'classnames/bind'
import React, { useRef } from 'react'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import {
  DeviceType,
  useDeviceType,
  useIsHover,
} from '@unlikelystudio/react-hooks'
import Slider from '@unlikelystudio/react-slider'

import { CtaProps } from '~/components/Abstracts/Cta'
import InlineCta from '~/components/UI/InlineCta'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type ProductReassuranceProps = {
  className?: string
  items: CtaProps[]
}

function ProductReassurance({ className, items }: ProductReassuranceProps) {
  const customSliderRef = useRef()
  const [isHovered, callbacks] = useIsHover()
  const device = useDeviceType()

  const isHovering = device === DeviceType.mobile ? false : isHovered

  return (
    <div className={cx(css.ProductReassurance, className)} {...callbacks}>
      <div className={css.wrapper} ref={customSliderRef}>
        <Slider
          className={cx(css.slider)}
          infinite={true}
          autoIsSlider={false}
          customSliderRef={customSliderRef}
          autoPlay={{ speed: isHovering ? 0 : -0.2 }}>
          {items?.map((item, index) => {
            const hasLink = !!item?.href

            return (
              <div className={css.item} key={`reassurance_items_${index}`}>
                <InlineCta
                  isDiv={!hasLink}
                  textPreset={GlobalTextPreset.Cta12GroteskRegular}
                  textStyling={GlobalTextStyling.Capitalize}
                  theme={GlobalThemeColors.Gray}
                  lineProps={{ isVisible: hasLink }}
                  {...item}
                />

                <span className={css.separator}>&#8226;</span>
              </div>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}

ProductReassurance.defaultProps = {}

export default ProductReassurance
